import React from 'react';

import { SectionContainer, SectionTitle } from './styles';

interface SectionProps {
  background?: string;
  title?: string;
}

const Section: React.FC<SectionProps> = ({ children, background, title }) => {
  return (
    <>
      <SectionTitle>{title}</SectionTitle>
      <SectionContainer style={{ background }}>{children}</SectionContainer>
    </>
  );
};

export default Section;
